import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Image from '../../components/AppImage';
import { PUBLIC_PAGE_METADATA } from '../../config/publicPageMetadata.mjs';

const LegalPageLayout = ({ title, effectiveDate, path, children }) => {
  const canonicalUrl = path ? `https://webforms.biz${path}` : undefined;
  const metadata = PUBLIC_PAGE_METADATA[path] || {
    title: `${title} — WebForms.biz`,
    description: `${title} for WebForms.biz`,
  };
  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
        {canonicalUrl && <meta property="og:title" content={metadata.title} />}
        {canonicalUrl && <meta property="og:description" content={metadata.description} />}
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Header */}
        <header className="border-b border-border bg-card">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <Image
                src="/assets/images/web-forms-logo-1769801123836.png"
                alt="WebForms.biz logo"
                className="w-40 h-auto object-contain"
              />
            </Link>
            <nav className="flex items-center gap-6 text-sm">
              <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms</Link>
              <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy</Link>
              <Link to="/authentication" className="text-primary hover:text-primary/80 font-medium">Sign in</Link>
            </nav>
          </div>
        </header>

        {/* Content */}
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
          <h1 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">{title}</h1>
          <p className="text-sm text-muted-foreground mb-10">Effective date: {effectiveDate}</p>
          <div className="legal-content space-y-8 text-foreground leading-relaxed">
            {children}
          </div>
        </main>

      </div>
    </>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-xl font-heading font-semibold text-foreground mb-3">{heading}</h2>
    <div className="space-y-3 text-[15px] text-muted-foreground">{children}</div>
  </section>
);

export default LegalPageLayout;
